export const isValidURL = (url: string) => {
    // eslint-disable-next-line no-useless-escape
    return /[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)?/gi.test(url.trim());
};
